import { useState, useEffect, useCallback, useContext } from 'react';

import LoaderContext from '../context/LoaderProvider';
import { getlocationsMonthly, getPosLinesMonthly } from '../services/monthlyServiceRequest';

import useToast from './useToast';

const useUbicationPositionLine = (idMonthlyServiceRequest, refreshHasLocations, filter) => {
  const [data, setData] = useState();
  const [isOrderByUbication, setIsOrderByUbication] = useState(true);
  const [refreshFetch, setRefreshFetch] = useState(false);

  const { setLoader } = useContext(LoaderContext);

  const { setNewToast } = useToast();

  const getUbicationsOLines = useCallback(
    async (filters) => {
      const typeUbications = () => {
        if (filters?.ubicationType) {
          return [filters?.ubicationType?.id];
        }
        if (filters?.tipoUbicacionesIds) {
          return filters?.tipoUbicacionesIds?.map((ubic) => ubic);
        }

        return [];
      };

      const ubications = () => {
        if (filters?.ubications) {
          return [filters?.ubications?.id];
        }
        if (filters?.ubicacionesIds) {
          return filters?.ubicacionesIds?.map((ubic) => ubic);
        }

        return [];
      };

      try {
        setLoader(true);
        const body = {
          ...(isOrderByUbication && {
            equiposIds: filters?.towerEquipments
              ? filters?.towerEquipments?.map((equip) => equip?.id)
              : filters?.equiposIds?.map((equip) => equip)
          }),
          ...(isOrderByUbication && {
            eventosIds: filters?.events
              ? filters?.events?.map((evnt) => evnt?.id)
              : filters?.eventosIds?.map((evnt) => evnt)
          }),
          tipoUbicacionesIds: typeUbications(),
          ubicacionesIds: ubications(),
          posicionesLineas: filters?.posicionesLineas?.map((pos) => ({
            posicionId: pos?.posicionId,
            lineaId: pos?.lineaId,
            posicion: pos?.posicion,
            linea: pos?.linea
          }))
        };

        const response = isOrderByUbication
          ? await getlocationsMonthly(idMonthlyServiceRequest, body)
          : await getPosLinesMonthly(idMonthlyServiceRequest, body);

        setData(response);
        setLoader(false);
      } catch (err) {
        setLoader(false);
        setNewToast({
          type: 'ERROR',
          message: err.message
        });
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isOrderByUbication]
  );

  useEffect(() => {
    if (filter?.haveFilters) getUbicationsOLines(filter);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOrderByUbication, refreshHasLocations, refreshFetch, filter]);

  return {
    data,
    setIsOrderByUbication,
    isOrderByUbication,
    setRefreshFetch,
    getUbicationsOLines,
    refreshFetch
  };
};

export default useUbicationPositionLine;
